"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingData = exports.TRANSLATION = exports.TEXT = exports.TEMPLATE_STR = exports.STATE_TEXT = exports.STATE_ICON_COLOR = exports.STATE_ICON = exports.STATE = exports.PARTIAL_CHECKEDIN = exports.CHECKING_STATUS = exports.CHECKING_STATE_TEXT_COLOR = exports.CHECKING_STATE_LABEL_COLOR = exports.BOOKING_CONFIRMED = void 0;
var STATE = {
  dotrez_pending: 'dotrez_pending',
  dotrez_confirmed: 'dotrez_confirmed',
  dotrez_cfar_cancel: 'dotrez_cfar_cancel',
  ota_failed: 'ota_failed',
  ota_confirmed: 'ota_confirmed',
  ota_processing: 'ota_processing'
};
exports.STATE = STATE;
var STATE_TEXT = {
  dotrez_pending: '',
  dotrez_confirmed: '',
  dotrez_cfar_cancel: 'orange',
  ota_failed: '',
  ota_confirmed: '',
  ota_processing: ''
};
exports.STATE_TEXT = STATE_TEXT;
var STATE_ICON = {
  ota_processing: 'HourglassFullIcon',
  ota_confirmed: 'CheckCircleIcon',
  ota_failed: 'CancelIcon',
  dotrez_pending: 'MonetizationOnRounded',
  dotrez_confirmed: 'CheckCircleIcon',
  dotrez_cfar_cancel: 'CancelIcon'
};
exports.STATE_ICON = STATE_ICON;
var STATE_ICON_COLOR = {
  ota_processing: 'yellow',
  ota_confirmed: 'tertiary',
  ota_failed: 'orange',
  dotrez_pending: 'yellow',
  dotrez_confirmed: 'tertiary',
  dotrez_cfar_cancel: 'orange'
};
exports.STATE_ICON_COLOR = STATE_ICON_COLOR;
var CHECKING_STATE_TEXT_COLOR = {
  allCheckedIn: 'tertiaryDark',
  notCheckedIn: 'primary',
  partialCheckedIn: 'secondaryBlue'
};
exports.CHECKING_STATE_TEXT_COLOR = CHECKING_STATE_TEXT_COLOR;
var CHECKING_STATE_LABEL_COLOR = {
  allCheckedIn: 'tertiaryLight',
  notCheckedIn: 'primaryLight',
  partialCheckedIn: 'blueLight'
};
exports.CHECKING_STATE_LABEL_COLOR = CHECKING_STATE_LABEL_COLOR;
var TEXT = {
  flex: 'flex',
  displayFlex: 'displayFlex',
  default: 'default',
  greyDarker: 'greyDarker',
  greyDark: 'greyDark',
  primaryDark: 'primaryDark',
  titleSmall: 'titleSmall',
  span: 'span',
  div: 'div',
  sub: 'sub',
  titleXXLarge: 'titleXXLarge',
  secondary: 'secondary',
  small: 'small',
  tiny: 'tiny',
  XSmall: 'XSmall',
  micro: 'micro',
  center: 'center',
  block: 'block',
  textLarge: 'textLarge',
  black: 'black',
  white: 'white',
  button: 'button',
  desktop: 'desktop',
  true: 'true',
  medium: 'medium',
  large: 'large',
  normal: 'normal',
  titleNormal: 'titleNormal',
  tertiaryLight: 'tertiaryLight',
  tertiaryDark: 'tertiaryDark',
  yellow: 'yellow',
  yellowLight: 'yellowLight',
  oldLace: 'oldLace',
  neutral: 'neutral',
  primary: 'primary'
};
exports.TEXT = TEXT;
var TRANSLATION = {
  referenceNumber: 'Reference number',
  paymentPending: 'Pending payment',
  bookingNumber: 'Booking number',
  payNow: 'Pay now',
  bookingConfirmed: 'Booking confirmed',
  manageBooking: 'Manage booking',
  downloadItienairy: 'Download itienairy',
  bookingProcessing: 'Booking processing',
  bookingFailed: 'Booking failed',
  applicationSuccessful: 'Application successful',
  viewRefundCase: 'View refund case',
  searchNewFlight: 'Search new flight',
  refundMessage: 'We are now proceessing the refund back to your original payment method.This may take up to 1 month',
  checkInStatus: 'Check-in status',
  allCheckedIn: 'All Checked-in',
  allCheckedInMessage: 'Ready to take off with us? Remember, all guests must present their e-boarding pass at security and boarding.',
  viewEboardingPass: 'View e-boarding pass',
  notCheckedIn: 'Not Checked-in',
  notCheckedInMessage: 'Check-in is now open. You can save time at the airport by checking in online.',
  checkIn: 'Check-in',
  partialCheckedIn: '{0} of {1} checked-in',
  partialCheckedInMessage: 'Check-in is now open. Kindly complete online check-in for all guests and receive your e-boarding pass.',
  bookingCancelled: 'Booking cancelled',
  termsText: 'We’ve cancelled your booking as requested. Any refunds will be bound by the ',
  termsLinkText: 'terms and conditions of Easy Cancel.',
  refundStatus: 'Refund Status',
  succesful: 'Succesful',
  refundText: 'We’ve completed your request and informed your bank. Contact your bank to follow up with your refund.',
  viewRefundToggle: 'View refund progress',
  hideRefundToggle: 'Hide refund progress',
  refundSummaryMessage: 'Refund request'
};
exports.TRANSLATION = TRANSLATION;
var bookingData = {
  bookingStatus: 'bookingFailed',
  bookingIcon: 'FailedIcon',
  bookingText: 'referenceNumber',
  bookingId: '12345678',
  banners: [{
    type: 'info',
    // eslint-disable-next-line max-len
    text: 'We are sorry .We cannot confirm your booking. We will refund the ful amount that was charged to your original payment method.'
  }],
  refund: {
    key: 'refundStatus',
    refundStatus: 'applicationSuccessful',
    refundMessage: 'refundMessage'
  }
};
exports.bookingData = bookingData;
var TEMPLATE_STR = {
  email: "{email}",
  currency: "{currency}",
  amount: "{amount}",
  name: "{name}",
  orderId: "{orderId}",
  dialingNumber: "{dialingNumber}",
  mobileNumber: "{mobileNumber}"
};
exports.TEMPLATE_STR = TEMPLATE_STR;
var CHECKING_STATUS = 'checkInStatus';
exports.CHECKING_STATUS = CHECKING_STATUS;
var BOOKING_CONFIRMED = 'bookingConfirmed';
exports.BOOKING_CONFIRMED = BOOKING_CONFIRMED;
var PARTIAL_CHECKEDIN = 'partialCheckedIn';
exports.PARTIAL_CHECKEDIN = PARTIAL_CHECKEDIN;